import { environment } from '@accredible-frontend-v2/envs';
import { enableProdMode, ViewEncapsulation } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { CourseFinderModule } from './app/core/course-finder.module';

if (environment.type === 'production') {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(CourseFinderModule, {
    defaultEncapsulation: ViewEncapsulation.Emulated,
  })
  .catch((err) => console.error(err));
